import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ActiveDate from './components/ActiveDate'
import InactiveDate from './components/InactiveDate'

import './style.scss'

export default class ParticipationElement extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object.isRequired,
        endDate: PropTypes.string,
        handleOnHover: PropTypes.func.isRequired,
        inactive: PropTypes.bool,
        index: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        pinnedIndex: PropTypes.string,
        pinParticipationElement: PropTypes.func.isRequired,
        startDate: PropTypes.string,
        timelineDurationInDays: PropTypes.number,
        timelineEndDate: PropTypes.object,
        timeLineStartDate: PropTypes.object,
        translates: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const { startDate, endDate, inactive } = this.props

        if (!startDate && !endDate) return null

        if (inactive) return <InactiveDate {...this.props} />
        if (!inactive) return <ActiveDate {...this.props} />

        return null
    }
}
